/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.6.7",
    versionName: "0.3.0-nightly.2026.6.7",
    versionChannel: "nightly",
    buildDate: "2026-06-07T00:37:34.553Z",
    commitHash: "262bb6c75c32207f939fc9133860d8039ce05476",
};
